/**
 * @file enterpriseのmodal動作
 *
 */
'use strict';

/**
 * @classname EnterpriseModalView
 * @classdesc enterpriseのmodal動作
 */
export default class EnterpriseModalView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('EnterpriseModalView.constructor');
		this._$e = $e;
		this._$modal = this._$e.find('.modal');
		this._$modal_wrap = this._$e.find('.modal_wrap');
		this._$close = this._$e.find('.close');
		this._$modal.on('click', () => this.onClickModal());
		this._$close = this._$e.find('.close');
		this._$close.on('click', () => this.onClickClose());
		this._$modal_bg = this._$e.find('.modal_bg');
		this._$modal_bg.on('click', () => this.onClickModalBg());
	}

	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof EnterpriseModalView
	 * @return {undefined}
	 */
	onClickModal() {
		console.log('EnterpriseModalView.onClick');
		this._$modal_wrap.fadeIn();
	}
	onClickClose() {
		console.log('EnterpriseModalView.onClick');
		this._$modal_wrap.fadeOut();
	}
	onClickModalBg() {
		console.log('EnterpriseModalView.onClick');
		this._$modal_wrap.fadeOut();
	}
}
